<template>
  <div class="dashboard-guarantees-block">
    <Tabs class="" v-model="curTab" :animated="false" style="height:100%">
      <TabPane label="即将到期" name="deadline">
        <Table ref="dataTable"
          size="small"
          stripe
          disabledHover
          :height="tabContentHeight"
          :columns="deadlineColumns"
          :data="deadlineData">
        </Table>
      </TabPane>
      <TabPane label="待办业务" name="todo">
        <Table ref="dataTable"
          size="small"
          stripe
          disabledHover
          :height="tabContentHeight"
          :columns="todoColumns"
          :data="todoData">
        </Table>
      </TabPane>
      <TabPane label="待确认通知书" name="todoProjectRegister" v-if="supvPerms.canAuditProjectRegister">
        <Table ref="dataTable"
          size="small"
          stripe
          disabledHover
          :height="tabContentHeight"
          :columns="todoProjectRegisterColumns"
          :data="todoProjectRegisterData">
        </Table>
      </TabPane>
      <Button size="small" slot="extra" @click="more">更多</Button>
    </Tabs>
  </div>
</template>

<script>
export default {
  data () {
    return {
      curTab: 'deadline',
      varieties: [],
      tabContentHeight: null,
      todoColumns: [
      {
          title: '地区',
          key: 'cityName',
          width: 160,
          render: (h, params) => {
            return h('span', null, params.row.cityName)
          }
        },
        {
          title: '项目',
          key: 'prjName',
          ellipsis: true,
          render: (h, params) => {
            return h('span', null, [
              h('span', null, `[${this.getVarietyName(params.row.variety)}]`),
              h('router-link', {
                attrs: {
                  title: params.row.prjName
                },
                props: {
                  to: {
                    name: 'guarantee-detail',
                    params: {
                      orderNumber: params.row.orderNumber
                    }
                  }
                }
              }, params.row.prjName)
            ])
          }
        },
        {
          title: '创建时间',
          key: 'createTime',
          width: 120,
          render: (h, params) => {
            return h('span', null, this.$moment(params.row.createTime).format('YYYY-MM-DD'))
          }
        },
      ],
      todoData: [],
      deadlineColumns: [
        {
          title: '地区',
          key: 'cityName',
          width: 160,
          render: (h, params) => {
            return h('span', null, params.row.cityName)
          }
        },
        {
          title: '项目',
          key: 'prjName',
          ellipsis: true,
          render: (h, params) => {
            return h('span', null, [
              h('span', null, `[${this.getVarietyName(params.row.variety)}]`),
              h('router-link', {
                attrs: {
                  title: params.row.prjName
                },
                props: {
                  to: {
                    name: 'guarantee-detail',
                    params: {
                      orderNumber: params.row.orderNumber
                    }
                  }
                }
              }, params.row.prjName)
            ])
          }
        },
        {
          title: '天数',
          key: 'type',
          width: 80,
          render: (h, params) => {
            return h('span', null,
              new Date(params.row.gEndDate) > new Date() ?
                this.$moment(params.row.gEndDate).diff(this.$moment(), 'days') + '天'
                : '已过期'
            )
          }
        },
      ],
      deadlineData: [],
      queryToDo: {
        statusList: null
      },
      expireInDays: 60,
      supvPerms: {
        canAuditGuarantor: false,
        canPreAuditGuarantor: false,
        canBlacklistGuarantor: false,
        canClaim: false,
        canAddProjectRegister: false,
        canAuditProjectRegister: false,
        projectRegisterMode: null
      },
      todoProjectRegisterColumns: [
      {
          title: '地区',
          key: 'cityName',
          width: 160,
          render: (h, params) => {
            return h('span', null, params.row.cityName)
          }
        },
        {
          title: '项目',
          key: 'prjName',
          ellipsis: true,
          render: (h, params) => {
            return h('span', null, [
              h('router-link', {
                attrs: {
                  title: params.row.projectName
                },
                props: {
                  to: {
                    name: 'project-register-detail',
                    params: {
                      orderNumber: params.row.orderNumber
                    }
                  }
                }
              }, params.row.projectName)
            ])
          }
        },
        {
          title: '创建时间',
          key: 'createTime',
          width: 120,
          render: (h, params) => {
            return h('span', null, this.$moment(params.row.createTime).format('YYYY-MM-DD'))
          }
        },
      ],
      todoProjectRegisterData: [],
    }
  },
  watch: {
    '$store.getters.screenHeight': function () {
      this.calcTabContentHeight()
    },
    '$store.getters.screenWidth': function () {
      this.calcTabContentHeight()
    }
  },
  async mounted () {
    this.initVarieties()
    let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
    if (userRole === '保证人') {
      this.queryToDo.statusList = [6, 7]
    } else if (userRole === '监管人') {
      this.queryToDo.statusList = [0, 2, 8, 10]
      await this.getMySupervisionPermission()
      if (this.supvPerms.canAuditProjectRegister) {
        this.todoProjectRegisterData = await this.initProjectRegisterData({
          status: 0
        })
      }
    } else if (userRole === '总监管人') {
      this.queryToDo.statusList = [0, 2, 8, 10]
    } else {
      this.queryToDo.statusList = [0, 2, 8, 10]
    }
    this.todoData = await this.initData(this.queryToDo)
    this.deadlineData = await this.initData({
      expireInDays: this.expireInDays
    })
    this.calcTabContentHeight()
  },
  methods: {
    calcTabContentHeight () {
      if (!document.querySelector('.dashboard-guarantees-block')) {
        return false
      }
      let blockHeight = document.querySelector('.dashboard-guarantees-block').clientHeight
      this.tabContentHeight = blockHeight - 36 - 16 // 减去ivu-tab-bar高度和margin
      // console.log(blockHeight, this.tabContentHeight)
    },
    initData (query) {
      return new Promise((resolve, reject) => {
        this.$Api.Guarantee.listGuarantees(query, 1, 7).catch(err => {
          this.$Message.error(err.message)
          reject(err)
        }).then(res => {
          resolve(res.data)
        })
      })
    },
    async getMySupervisionPermission () {
      await this.$Api.Supervisor.getMySupervisorPermissions()
      .then((res) => {
        // console.log(res)
        this.supvPerms = res
        return Promise.resolve()
      })
      .catch((err) => {
        this.supvPerms = {
          canAuditGuarantor: false,
          canPreAuditGuarantor: false,
          canBlacklistGuarantor: false,
          canClaim: false,
          canAddProjectRegister: false,
          canAuditProjectRegister: false,
          projectRegisterMode: null
        }
        return Promise.reject(err)
      })
    },
    initProjectRegisterData (query) {
      return new Promise((resolve, reject) => {
        this.$Api.ProjectRegister.listProjectRegisters(query, 1, 8).catch(err => {
          this.$Message.error(err.message)
          reject(err)
        }).then(res => {
          resolve(res.data)
        })
      })
    },
    initVarieties () {
      this.$Api.Guarantee.getGuaranteeVarieties('ALL')
      .then((res) => {
        this.varieties = res
      })
      .catch(err => {
        this.$Message.error(err.message)
      })
    },
    getVarietyName (varietyId, isFullName = false) {
      if (this.varieties && this.varieties.length) {
        let v = this.varieties.find(o => o.id === varietyId)
        if (!v) {
          return '未知'
        }
        if (isFullName) {
          return v.fullName
        } else {
          return v.name
        }
      }
    },
    getVarietyTagColor (varietyId) {
      return this.$common.guaranteeVarietyColor[varietyId]
    },
    more () {
      switch (this.curTab) {
        case 'todo':
          this.$router.push({name: 'guarantee-list', params: {statusList: this.queryToDo.statusList}})
          break
        case 'deadline':
          this.$router.push({name: 'guarantee-list', params: {expireInDays: this.expireInDays}})
          break
        case 'todoProjectRegister':
          this.$router.push({name: 'project-register-list', params: {status: 0}})
          break
        default:
          this.$router.push({name: 'guarantee-list', params: {statusList: this.queryToDo.statusList}})
          break
      }
    }
  }
}
</script>

<style lang="less">
.dashboard-guarantees-block {
  position: relative;
  height: 100%;
  .ivu-table {
    &::before {
      display: none
    }
  }
}
</style>